import { t } from '@framework/i18n/intl/i18next.ts';
import type React from 'react';
import { useEffect, useState } from 'react';

export interface IMessageFilteredListProps
  extends React.HTMLAttributes<HTMLDivElement> {
  /** Il messaggio deve essere mostrato solo se la lista è filtrata. */
  visible?: boolean;
  /** Numero di elementi filtrati. */
  items?: number | null;
  /** Messaggio per SR. */
  message?: React.ReactNode;
  /** Azione. Elemento dopo il messaggio. */
  action?: React.ReactNode;
  /** Permette di modificare il messaggio letto dall'SR quando si rimuovono i filtri
   *  @default 'Nessun filtro applicato'*/
  afterActionMessage?: React.ReactNode;
}

/**
 * Componente che mostra il numero di elementi filtrati e un messaggio.
 * Imposta inoltre il container per i messaggi per soddisfare l'accessibilità.
 */
export function MessageFilteredList(props: IMessageFilteredListProps) {
  const {
    visible,
    items,
    message,
    action,
    afterActionMessage,
    style,
    ...divProps
  } = props;

  // registriamo se il messaggio è stato mostrato almento una volta
  const [shown, setShown] = useState(false);
  useEffect(() => {
    if (visible && !shown) {
      setShown(true);
    }
  }, [visible, shown]);

  return (
    <div aria-live="assertive" aria-atomic="true" aria-relevant="text">
      {/* Messaggio da mostrare alla rimozione dei filtri */}
      {shown && !visible && (
        <span className="sr-only">
          {afterActionMessage ??
            t(
              'message-filtered-list.invisible.sr-default-message',
              'Nessun filtro applicato',
            )}
        </span>
      )}

      {visible && items != null && (
        <div
          style={{ marginBottom: 12, textAlign: 'center', ...style }}
          {...divProps}
        >
          <strong>{items}</strong> <span>{message}</span> {action}
        </div>
      )}
    </div>
  );
}
